import React, { useState } from 'react'

//Bibliotecas
import styled from 'styled-components';
//Componentes
import FlexContainer from '../../common/FlexContainer';
import Description from './components/Description';


function CasoPractico({ data }) {
    //Estados
    const [steps, setSteps] = useState(data);
    

    //Lista de pasos
    const listSteps = steps.map((step, index) =>
        <Step width={step?.width} key={index}>
            {step?.img &&
                <img src={step?.img}></img>
            }
            {step?.url &&
                <iframe src={`${step?.url}?rel=0`} width='100%' height='251px' allowFullScreen></iframe>
            }
            <Description step={step}></Description>
        </Step>
    );

    return (
        <FlexContainer backgroundColor='transparent' textAlign='left' flexDirection='column'>
            {listSteps}
        </FlexContainer>

    )
}

export default CasoPractico


const Step = styled.div` 
    box-sizing:border-box;
    display:flex;
    flex-direction:row;
    width:100%;
    justify-content:center;
    align-items:center;
    color:var(--color-blanco);
    padding:0 32px;

    &:nth-child(even){
        background-color:var(--color-morado-claro);
    }
    &:nth-child(odd){
        background-color:var(--color-azul-oscuro);
    }

    img{
        width:${props => props.width ? props.width : '20%'};
        height: auto;
        margin-right:32px;
        padding:24px;
        border-radius:32px;
    }

    iframe{
        margin-right:32px;
        border:none;
        padding:24px;
        border-radius:30px;
    }

`;
